import { render, staticRenderFns } from "./Discount.vue?vue&type=template&id=5567dac2&scoped=true"
import script from "./Discount.vue?vue&type=script&lang=js"
export * from "./Discount.vue?vue&type=script&lang=js"
import style0 from "./Discount.vue?vue&type=style&index=0&id=5567dac2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5567dac2",
  null
  
)

export default component.exports